import React, { useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Typography,
  Tabs,
  TabsHeader,
  Tab,
} from "@material-tailwind/react";
import {
  AcademicCapIcon,
  DocumentTextIcon,
  GlobeAltIcon,
  ScaleIcon,
  TrophyIcon,
} from "@heroicons/react/24/solid";
import Drawer from "react-bottom-drawer";

import ScientificDocs from "./scientificDocs";
import LegalDocs from "./legalDocs";
import WisdomDocs from "./wisdomDocs";
import ContributeDocs from "../../ContributeDocs";
import { Container, Divider, Grid } from "@mui/material";
import MyContributeWebsites from "../../../../components/dedicate/my-contribute-website";
import Leaderboard from "../../../../components/SettingsPages/LeaderBoard/Leaderboard";
import AllScientificDocs from "./AllScientificDocs";
import { useSelector } from "react-redux";
import DocMetaDeta from "../../../DocMetaDeta";
import UserService from "../../../../KeyCloackServices/UserService";

const TrainBook = () => {
  const [selectedDocsApi, setSelectedDocsApi] = useState("docs");
  const { selectedMetaData } = useSelector((state) => state.dataFlow);
  const [showModal, setShowModal] = useState(false);

  const options = [
    {
      label: UserService.getRole()?.roles?.includes("admin")
        ? "All Docs"
        : "My Docs",
      value: "docs",
      icon: DocumentTextIcon,
      component: <ScientificDocs />,
    },
    {
      label: "Science Docs",
      value: "science",
      icon: AcademicCapIcon,
      component: <AllScientificDocs />,
    },
    {
      label: "Law Docs",
      value: "law",
      icon: ScaleIcon,
      component: <LegalDocs />,
    },
    {
      label: "Wisdom Docs",
      value: "websites",
      icon: GlobeAltIcon,
      component: <WisdomDocs />,
    },
    {
      label: "Leaderboard",
      value: "leaderboard",
      icon: TrophyIcon,
      component: <Leaderboard />,
    },
  ];

  useEffect(() => {
    const handleToggleReferences = () => {
      if (window.innerWidth < 768) {
        setShowModal(true);
      }
    };
    handleToggleReferences();
  }, [selectedMetaData]);

  return (
    <Container maxWidth="xl" className="mt-2">
      <Grid container spacing={2}>
        <Grid item xs={12} md={selectedMetaData ? 8 : 12}>
          <Card className="overflow-y-auto max-h-[calc(100vh)] py-7  md:max-h-[calc(100vh)] lg:max-h-[calc(100vh)] xl:max-h-[calc(100vh)]">
            <CardHeader
              color="gray"
              className="mb-8 mt-3 p-6 flex items-center"
            >
              <Typography variant="h6" color="white">
                {`Contribute research`}
              </Typography>
            </CardHeader>
            <CardBody className="overflow-x-auto px-2 pt-0 pb-2">
              <div className="pt-4 px-3">
                <div className="text-lg font-semibold mb-4">
                  Upload document(s)
                </div>
                <ContributeDocs docType="scientific" />
                <Divider>OR</Divider>

                <MyContributeWebsites />
              </div>
              <hr className="mb-4" />
              <Tabs value={selectedDocsApi}>
                <TabsHeader
                  indicatorProps={{
                    className: "bg-gray-900/10 shadow-none !text-gray-900",
                  }}
                  className="bg-transparent max-[480px]:max-w-[180px] justify-center bg-slate-200 rounded-[20px] p-1 me-5 min-[480px]:mb-12 flex sm:flex-none flex-wrap"
                >
                  {options.map(({ label, value, icon }) => (
                    <Tab
                      key={value}
                      value={value}
                      className="w-auto"
                      onClick={() => setSelectedDocsApi(value)}
                    >
                      <div className="flex items-center gap-2 !text-xs sm:!text-base">
                        {React.createElement(icon, {
                          className: "w-5 h-5",
                        })}
                        {label}
                      </div>
                    </Tab>
                  ))}
                </TabsHeader>
              </Tabs>
              <>
                {
                  options.find((option) => option.value === selectedDocsApi)
                    ?.component
                }
              </>
            </CardBody>
          </Card>
        </Grid>
        {selectedMetaData && (
          <Grid
            item
            md={4}
            className="d-none d-md-block bg-white border border-l"
          >
            <DocMetaDeta />
          </Grid>
        )}
      </Grid>

      <Drawer
        isVisible={!!(selectedMetaData && showModal)}
        onClose={() => setShowModal(false)}
      >
        <DocMetaDeta />
      </Drawer>
    </Container>
  );
};

export { TrainBook };
